export default __webpack_public_path__ + "static/media/homepage-mountain.b7ab6088.jpg";